module.exports = __webpack_public_path__ + "static/media/gvanta-logo.603ac060.png";